// extracted by mini-css-extract-plugin
export default {"noScrollBar":"layout_noScrollBar__zTXFU"};